/**
 * Eine Angabe in einer Listenzeile: dezentes Icon, dahinter der Text in einer Zeile, mit Ellipse
 * gekürzt. Ziffern gleich breit, damit Daten untereinander fluchten. Das Icon ordnet die Angabe
 * ein und soll nicht hervortreten – `detailIconSx` gibt ihm Größe und Farbe.
 */
import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../../styles/colors";

export const detailIconSx = {
  fontSize: 14,
  color: colors.text.disabled,
  flexShrink: 0,
};

const DetailCell: React.FC<{
  /** Fehlt, wenn die Stelle in der Zeile schon sagt, was die Angabe ist */
  icon?: React.ReactNode;
  children: React.ReactNode;
}> = ({ icon, children }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
    {icon}
    <Typography
      variant="caption"
      noWrap
      sx={{
        display: "block",
        color: colors.text.secondary,
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {children}
    </Typography>
  </Box>
);

export default DetailCell;
